import { FC } from 'react';

import {
  buildIndxAggregation,
  buildIndxTermsFilter,
  IndxProvider,
  UseIndxOptions,
} from '@opendoor/tessellation';

import { useSessionContext } from '../../../contexts/SessionContext';
import { SEARCH_WORK_ORDER_INDEX } from '../../../graphql/queries/indextrious/SearchWorkOrderIndex';
import { notEmpty } from '../../../utils/types';
import { FIELDS, PAGE_SIZE } from '../constants';

const WorkOrderProvider: FC<Omit<UseIndxOptions, 'path'>> = ({ children, ...indxProps }) => {
  const { session } = useSessionContext();
  const branchesIds: string[] = (session.human?.vendorBranches.filter(notEmpty) || []).map(
    (b) => b.id,
  );

  const branchFilter = buildIndxTermsFilter(FIELDS.ASSIGNED_TO_BRANCH_ID, branchesIds);
  const isAdmin = session.human?.opendoor_internal_access || false;

  const defaultFilters = isAdmin ? [] : [branchFilter];

  const filters = [...(indxProps.filters || []), ...defaultFilters];

  const progressAgg = buildIndxAggregation(FIELDS.PROGRESS);
  const inAllTabAgg = buildIndxAggregation(FIELDS.IN_ALL_TAB);

  return (
    <IndxProvider
      query={SEARCH_WORK_ORDER_INDEX}
      path="indextrious.searchTradePartnerWorkOrderIndex"
      {...indxProps}
      pageSize={PAGE_SIZE}
      aggregationFilters={[...defaultFilters]}
      filters={[...filters]}
      rememberFilters={false}
      aggregations={[...(indxProps.aggregations || []), progressAgg, inAllTabAgg]}
    >
      {children}
    </IndxProvider>
  );
};

export default WorkOrderProvider;
